import { Component, Inject, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { SaleTeamMappingEmployeeInfo } from '../model/SaleTeamMappingEmployeeInfo.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from '../service/global.service';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../service/token.service';
import { environment } from 'src/environments/environment';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { ReportSaleSummaryBacklogByCompanyReturn } from '../model/ReportSaleSummaryBacklogByCompanyReturn.model';
//import { ChartOptions, ChartType } from 'chart.js';
//import { ChartDataSets } from 'chart.js';
//import * as ChartJS from 'chart.js';
//import ChartDataLabels from 'chartjs-plugin-datalabels';

declare var Chart: any; // Chart.js global object
declare var ChartDataLabels: any; // chartjs-plugin-datalabels global object

if (typeof Chart !== 'undefined' && typeof ChartDataLabels !== 'undefined') {
  Chart.plugins.register(ChartDataLabels);
}

interface ReportChartActualAtSaleSummaryByCustomerReturn {
  Year: string;
  SumActualPrice: number;
}

@Component({
  selector: 'app-asset-report-by-customer',
  templateUrl: './asset-report-by-customer.component.html',
  styleUrls: ['./asset-report-by-customer.component.css']
})
export class AssetReportByCustomerComponent implements OnInit {
  _ForK2: string;
  _EmpCode: string;
  _ParamEmpCode: string;
  
  baseurl: string;
  
  yearOptions: ProjectSaleInfo[] = [];
  
  yearSearch: string = null;
  ddlMonthStart: string = null;
  ddlMonthEnd: string = null;
  MonthStartName: string = '';
  MonthEndName: string = '';

  isMonthEndValid: boolean = true;
  yearErrorMessage: string = '';
  monthErrorMessage: string = '';

  MonthList = [
    { MonthCode: '1', MonthName: 'Jan' },
    { MonthCode: '2', MonthName: 'Feb' },
    { MonthCode: '3', MonthName: 'Mar' },
    { MonthCode: '4', MonthName: 'Apr' },
    { MonthCode: '5', MonthName: 'May' },
    { MonthCode: '6', MonthName: 'Jun' },
    { MonthCode: '7', MonthName: 'Jul' },
    { MonthCode: '8', MonthName: 'Aug' },
    { MonthCode: '9', MonthName: 'Sep' },
    { MonthCode: '10', MonthName: 'Oct' },
    { MonthCode: '11', MonthName: 'Nov' },
    { MonthCode: '12', MonthName: 'Dec' },
  ];

  BacklogByCustomerList: ReportSaleSummaryBacklogByCompanyReturn[] = [];
  CloseLostByCustomerList: ReportSaleSummaryBacklogByCompanyReturn[] = [];
  ProspectByCustomerList: ReportSaleSummaryBacklogByCompanyReturn[] = [];
  ActualChartList: ReportChartActualAtSaleSummaryByCustomerReturn[] = [];

  TotalPurchasePriceAll: number = 0;

  // *** ตัวแปรหลักสำหรับ Chart เดียวของคุณ ตามชื่อที่คุณต้องการ ***
  public graphLabels: string[] = []; // ใช้ string[] แทน Label[]
  public graphData: any[] = [];
  public barChartType: any = 'bar';
  public barChartLegend = true;
  IscompanyList: boolean = true;

  // *** barChartOptions: ตัวเลือกการแสดงผลของ Chart ที่ละเอียดตามที่คุณต้องการ ***
  public barChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
        ticks: {
          fontFamily: 'Inter, sans-serif'
        },
        gridLines: {
            display: false
        }
      }],
      yAxes: [{
        ticks: {
          beginAtZero: true,
          callback: function(value) {
            const numericValue = Number(value); // แปลงค่าเป็น number ก่อน
      if (numericValue >= 1000000) {
        return (numericValue / 1000000).toFixed(0);
      }
      return (numericValue)
          },
          fontFamily: 'Inter, sans-serif'
        },
        scaleLabel: {
          display: false ,
          labelString: 'Unit: Million Baht',
          fontFamily: 'Inter, sans-serif'
        }
      }]
    },
    tooltips: {
      callbacks: {
        label: function(tooltipItem, data) {
          const label = data.datasets[tooltipItem.datasetIndex].label || '';
          const value = tooltipItem.yLabel;
          return `${label}: ${Number(value).toLocaleString()}`;
        }
      }
    },
    hover: {
      mode: 'index',
      intersect: false
    },
    legend: {
      display: true,
      position: 'top',
      align: 'start',
      labels: {
        generateLabels: (chart) => {
      // สามารถปรับแต่ง legend ได้
      return [{
         text: 'Unit: Million Baht',
        fillStyle: 'rgba(0, 0, 0, 0)', // ทำให้สีของ legend เป็นโปร่งใส
        strokeStyle: 'rgba(0, 0, 0, 0)'
      }];
    }
    }
  },
  plugins: {
      datalabels: {
        anchor: 'end', // ตำแหน่งของ Label (end: บนสุด, start: ล่างสุด, center: ตรงกลาง)
        align: 'top', // จัดแนวของ Label (top, bottom, center)
        color: '#000', // สีตัวอักษรของ Label
        font: {
          weight: 'bold' // ทำให้ตัวอักษรหนา
        },
        formatter: function(value: any) { // ฟังก์ชันจัดรูปแบบตัวเลขที่จะแสดง
          const numericValue = Number(value);
          if (numericValue >= 0) {
            if (numericValue >= 1000000) {
              return (numericValue / 1000000).toFixed(2) + 'M';
            }
            return numericValue.toLocaleString();
            } else {
            return null; // หากค่าน้อยกว่าหรือเท่ากับ 0 จะไม่แสดง label
          }
        }
      }
    }
  };

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private activatedRoute: ActivatedRoute, private TokenService: TokenService) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._ParamEmpCode = this.activatedRoute.snapshot.params.EmpCode;
   }

  async ngOnInit(): Promise<void> {
    this._EmpCode = !!this._ParamEmpCode ? this._ParamEmpCode : localStorage.getItem("EmpCode");
    if (!!this._ForK2) {
      localStorage.setItem("EmpCode", this._ParamEmpCode);
    }

    await this.initializeComponent();
    await this.LoadBacklogByCustomerList();
    await this.LoadCloseLostByCustomerList();
    await this.LoadProspectByCustomerList();
    await this.LoadActualChartList();
    this.updateActualPriceChartData();
    this.MonthStartName = "Jan";
    this.MonthEndName = "Dec";    

    //$('#ModalAssetReportByCustomer').modal('show');
  }

  async initializeComponent() {
    await this.loadInitialData();
  }

  async loadInitialData() {
    await this.loadLeadYears();
    //await this.LoadSaleTarget(true);
  }

  async loadLeadYears() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      try {
        const result = await this.httpClient.get<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetLeadYears", httpOptions).toPromise();
        if (result && result.length > 0) {
          this.yearOptions = result;
          // Set the default year to the most recent year
          if (this.yearOptions.length >= 2) {
          this.yearSearch = result[result.length - 2].ProjectSaleYear;
          } else {
            this.yearSearch = result[result.length - 1].ProjectSaleYear;
          }
          //console.log('Default year set to:', this.yearSearch);
        } else {
          console.error('No years returned from GetLeadYears');
          // Set current year as fallback
          const currentYear = new Date().getFullYear();
          this.yearSearch = currentYear.toString();
        }
      } catch (error) {
        console.error('Error loading years:', error);
        // Set current year as fallback
        const currentYear = new Date().getFullYear();
        this.yearSearch = currentYear.toString();
      }
    }
  }

  onddlMonthStartChange(event: Event): void {
  const selectElement = event.target as HTMLSelectElement;
  this.ddlMonthStart = selectElement.value || null;

    if (this.ddlMonthStart === null || this.ddlMonthStart === 'null') {
    this.ddlMonthEnd = null;
  }

  this.validateMonthRange();
}

  onddlMonthEndChange(event: Event): void {
   const selectElement = event.target as HTMLSelectElement;
   this.ddlMonthEnd = selectElement.value || null;

   if (this.ddlMonthEnd === null || this.ddlMonthEnd === 'null') {
    this.ddlMonthStart = null;
  }

   this.validateMonthRange();
  }

  validateMonthRange(): void {
    this.monthErrorMessage = '';

    this.isMonthEndValid = true;
  }

  async btnSearch_OnClick() {
    $('#ModalAssetReportByCustomer').modal('hide');
    this.isMonthEndValid = true;
    this.monthErrorMessage = '';

  if (!this.yearSearch) {
    this.isMonthEndValid = false;
    this.monthErrorMessage = 'กรุณาเลือกปี';
    return;
  }

  // Helper function check null (include string "null")
  const isEmpty = (value: any) => {
    return value === null || 
           value === undefined || 
           value === '' || 
           value === 'null' ||  // Add this
           value === '0';
    };

    const isMonthStartEmpty = isEmpty(this.ddlMonthStart);
    const isMonthEndEmpty = isEmpty(this.ddlMonthEnd);

    // must select both or not select both
    if (isMonthStartEmpty !== isMonthEndEmpty) {
        this.isMonthEndValid = false;
        this.monthErrorMessage = 'กรุณาเลือก Month From และ Month To ให้ครบ';
        return;
    }

    // select both and check interval
    if (!isMonthStartEmpty && !isMonthEndEmpty) {
        const start = parseInt(this.ddlMonthStart.toString(), 10);
        const end = parseInt(this.ddlMonthEnd.toString(), 10);

        if (isNaN(start) || isNaN(end)) {
            this.isMonthEndValid = false;
            this.monthErrorMessage = 'ค่าเดือนไม่ถูกต้อง';
            return;
        }

        if (end < start) {
            this.isMonthEndValid = false;
            this.monthErrorMessage = 'Month To ต้องมากกว่าหรือเท่ากับ Month From';
            return;
      }
  }

    //console.log('Year:', this.yearSearch);
    //console.log('Month From Pass:', this.ddlMonthStart);
    //console.log('Month To Pass:', this.ddlMonthEnd);

    if (isMonthStartEmpty) {
    this.MonthStartName = "Jan";
  } else {
    this.MonthStartName = this.MonthList.find(m => m.MonthCode === this.ddlMonthStart.toString())?.MonthName || "Jan";
  }

  if (isMonthEndEmpty) {
    this.MonthEndName = "Dec";
  } else {
    this.MonthEndName = this.MonthList.find(m => m.MonthCode === this.ddlMonthEnd.toString())?.MonthName || "Dec";
  }

    const genYear = parseInt(this.yearSearch, 10);
    const yeargraphString = `${genYear},${genYear - 1}`;

    //console.log('Year:', this.yearSearch);
    //console.log('Month From Name:', this.MonthStartName);
    //console.log('Month To Name:', this.MonthEndName);
    console.log('yeargraphString', yeargraphString);

    await this.LoadBacklogByCustomerList();
    await this.LoadCloseLostByCustomerList();
    await this.LoadProspectByCustomerList();
    await this.LoadActualChartList();
    this.updateActualPriceChartData();
    $('#ModalAssetReportByCustomer').modal('show');

  }

  async btnclear_OnClick() {
    this.yearSearch = null;
    this.ddlMonthStart = null;
    this.ddlMonthEnd = null;

    this.isMonthEndValid = true;
    await this.loadLeadYears();
  }

  async LoadBacklogByCustomerList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      // Prepare search parameters
      var objectjson = {};
      objectjson['RequestEmpCode'] = this._EmpCode;
      objectjson['BacklogDetailYear'] = this.yearSearch;
      objectjson['MonthStart'] = this.ddlMonthStart;
      objectjson['MonthEnd'] = this.ddlMonthEnd;
  
      //console.log('objectjson', objectjson);
  
      try {
        const result = await this.httpClient.post<ReportSaleSummaryBacklogByCompanyReturn[]>(this.baseurl + "ProjectSaleReport/GetTop10BacklogByCompany", objectjson,
        httpOptions).toPromise();
          
        this.BacklogByCustomerList = result;
        //console.log('BacklogByCustomerList', this.BacklogByCustomerList);
        // this.processData();
        } catch (error) {
          console.error('API Error:', error);
      }
    }
  }

  async LoadCloseLostByCustomerList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      // Prepare search parameters
      var objectjson = {};
      objectjson['RequestEmpCode'] = this._EmpCode;
      objectjson['CloseLostDetailYear'] = this.yearSearch;
      objectjson['MonthStart'] = this.ddlMonthStart;
      objectjson['MonthEnd'] = this.ddlMonthEnd;
  
      //console.log('objectjson', objectjson);
  
      try {
        const result = await this.httpClient.post<ReportSaleSummaryBacklogByCompanyReturn[]>(this.baseurl + "ProjectSaleReport/GetTop10CloseLostByCompanyPipeline", objectjson,
        httpOptions).toPromise();
          
        this.CloseLostByCustomerList = result;
        //console.log('CloseLostByCustomerList', this.CloseLostByCustomerList);
        // this.processData();
        } catch (error) {
          console.error('API Error:', error);
      }
    }
  }

  async LoadProspectByCustomerList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      // Prepare search parameters
      var objectjson = {};
      objectjson['RequestEmpCode'] = this._EmpCode;
      objectjson['CloseLostDetailYear'] = this.yearSearch;
      objectjson['MonthStart'] = this.ddlMonthStart;
      objectjson['MonthEnd'] = this.ddlMonthEnd;
  
      //console.log('objectjson', objectjson);
  
      try {
        const result = await this.httpClient.post<ReportSaleSummaryBacklogByCompanyReturn[]>(this.baseurl + "ProjectSaleReport/GetTop10ProspectByCompanyPipeline", objectjson,
        httpOptions).toPromise();
          
        this.ProspectByCustomerList = result;
        console.log('ProspectByCustomerList', this.ProspectByCustomerList);
        // this.processData();
        } catch (error) {
          console.error('API Error:', error);
      }
    }
  }

  getTotalBacklog(): number {
    return this.BacklogByCustomerList.reduce((sum, item) => sum + item.TotalBacklogPrice, 0);
  }

  getTotalCloseLost(): number {
    return this.CloseLostByCustomerList.reduce((sum, item) => sum + item.TotalBacklogPrice, 0);
  }

  getTotalProspect(): number {
    return this.ProspectByCustomerList.reduce((sum, item) => sum + item.TotalBacklogPrice, 0);
  }

  async LoadActualChartList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      // Prepare search parameters
      const genYear = parseInt(this.yearSearch, 10);
      const yeargraphString = `${genYear},${genYear - 1}`;

      var objectjson = {};
      objectjson['RequestEmpCode'] = this._EmpCode;
      objectjson['ProjectSaleYear'] = yeargraphString;
      objectjson['MonthStart'] = this.ddlMonthStart;
      objectjson['MonthEnd'] = this.ddlMonthEnd;

      try {
        const result = await this.httpClient.post<ReportChartActualAtSaleSummaryByCustomerReturn[]>(this.baseurl + "ProjectSaleReport/GetActualByCustomer", objectjson,
        httpOptions).toPromise();

        // ใช้ ngZone.run() เพื่อบังคับให้ Angular ตรวจจับการเปลี่ยนแปลง
        
          this.ActualChartList = result;
          console.log('ActualChartList', this.ActualChartList);

          // เรียก generateChartData() ที่นี่
          if (this.ActualChartList && this.ActualChartList.length > 0) {
            
          }
        

      } catch (error) {
        console.error('API Error:', error);
      }
    }
  }

  private updateActualPriceChartData(): void {
    console.log('Updating Actual Price chart data...');
    if (!this.ActualChartList || this.ActualChartList.length === 0) {
      // ถ้าไม่มีข้อมูล หรือข้อมูลว่างเปล่า ให้ Chart ว่างเปล่า
      this.graphLabels = [];
      this.graphData = [];
      this.TotalPurchasePriceAll = 0; // เคลียร์ค่ารวมด้วย
      console.log('No ActualChartList data available for chart.');
      return;
    }

    // 1. แยก `Year` ออกมาเป็น Labels สำหรับแกน X
    //this.graphLabels = this.ActualChartList.map(item => item.Year);
    this.graphLabels = this.ActualChartList.map(item => `Actual ${item.Year.slice(2)}`);

    // 2. แยก `SumActualPrice` ออกมาเป็น Data สำหรับ Chart
    const actualPrices = this.ActualChartList.map(item => item.SumActualPrice);

    // 3. คำนวณผลรวมสำหรับ TotalPurchasePriceAll
    this.TotalPurchasePriceAll = actualPrices.reduce((sum, price) => sum + price, 0);

    // 4. กำหนด DataSets สำหรับ Chart
    this.graphData = [
      {
        data: actualPrices,
        label: 'ยอดรวมราคาจริง', // Label ของแท่งกราฟที่จะแสดงใน Legend และ Tooltip
        backgroundColor: 'rgba(75, 192, 192, 0.6)', // สีของแท่ง (เขียวฟ้าจางๆ)
        borderColor: 'rgba(75, 192, 192, 1)', // สีขอบของแท่ง
        borderWidth: 1, // ความหนาขอบ
        hoverBackgroundColor: 'rgba(75, 192, 192, 0.8)' // สีเมื่อเมาส์ชี้
      }
    ];

    console.log('graphLabels (updated):', this.graphLabels);
    console.log('graphData (updated):', this.graphData);
  }
  
  formatThaiCurrency(value: number | null | undefined): string {
    if (value == null || value === 0) return '0.00 พันบาท';

    const millionValue = value / 1_000_000;

    // case >= 0.01 ล้านบาท -> show as "ล้านบาท"
    if (millionValue >= 0.01) {
      return millionValue.toFixed(2) + ' ล้านบาท';
    }

    // case < 0.01 ล้านบาท -> show "พันบาท"
    return (value / 1_000).toFixed(2) + ' พันบาท';
  }

}
